<template>
  <ListboxItem v-bind="$props" @click="close">
    <template v-if="$slots.prefix" #prefix>
      <slot name="prefix" />
    </template>
  </ListboxItem>
</template>

<script setup lang="ts">
import { inject } from 'vue';

import { ListboxItemProps } from '../listbox/listbox-item-props.interface';
import ListboxItem from '../listbox/listbox-item.vue';
import { menuButtonInjectionKey } from './menu-button.token';

const props = defineProps<ListboxItemProps & { manualClose?: boolean }>();

const menuButton = inject(menuButtonInjectionKey);

function close() {
  if (!props.manualClose) {
    menuButton?.close();
  }
}
</script>
